import { Stack } from '@mui/material';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { APPBAR_HEIGHT } from '@/components/architecture/Layout/AppBar/AppBar.constants';
import { useNavigateToRoute } from '@/components/navigation/useNavigateToRoute';
import { ROUTE_KEYS } from '@/navigation/constants';
import { diagnostics } from '@/utils/diagnostics';

import { AdminSidebar } from './AdminSidebar';
import { useAuthorizedSettingsPages } from './AdminUsersPage/hooks/useAuthorizedAdminPages';

export function AdminPage() {
  const { navigate } = useNavigateToRoute();
  const tabs = useAuthorizedSettingsPages();

  useEffect(() => {
    if (tabs.length > 0) return;
    diagnostics.info('No authorized admin pages found; redirecting');
    // Discarded rather than returned: an effect's return value is its cleanup
    // function, and navigate() now resolves a promise under a data router.
    void navigate(ROUTE_KEYS.HOUSEHOLDS_LIST, {});
  }, [navigate, tabs.length]);

  return (
    <Stack
      direction="row"
      sx={{ height: `calc(100vh - ${APPBAR_HEIGHT})`, overflow: 'hidden' }}
    >
      <AdminSidebar />
      <Stack
        sx={{
          flex: 1,
          overflow: 'auto',
          height: `calc(100vh - ${APPBAR_HEIGHT})`,
        }}
      >
        <Stack
          spacing={1}
          p={2}
          // set position to relative so this is the canonical offset parent of the outlet children
          sx={{
            width: '100%',
            position: 'relative',
          }}
        >
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  );
}
